<div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="showErrorMessage">
    <strong>Sikertelen bejelentkezés!</strong>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
</div>

<mat-card>
    <mat-card-content>
      <form [formGroup]="loginForm" (ngSubmit)="submit()">
        <h2>Bejelentkezés</h2>
        <mat-form-field>
          <input matInput type="text" placeholder="Felhasználónév" formControlName="username" required>
        </mat-form-field>
        <mat-form-field>
          <input matInput type="password" placeholder="Jelszó"  formControlName="password" required>
        </mat-form-field>
        <button mat-raised-button color="primary">Bejelentkezés</button>
      </form>
    </mat-card-content>
  </mat-card>